import { useEffect, useMemo, useState } from "react";
import { createPriceMap, getVisibleMonthIndexes, getDateRangeFromVisibleMonths } from "../../utils/fareCalendar.js";
import { useFetchFareCalendar } from "./useFetchFareCalendar.js";
import { useActions, useSearchboxStore } from "../../store/searchBoxStore.js";
import { actions as searchActions } from "../../store/actions.js";
export const useFareCalendarEnabled = (segmentIndex) => {
    const store = useSearchboxStore();
    const searchType = store.searchbox.type;
    const segment = store.searchbox.searchSegments?.[segmentIndex];
    const hasValidFrom = Boolean(segment?.from?.some((l) => l.type === "CITY" || l.type === "AIRPORT"));
    const hasValidTo = Boolean(segment?.to?.some((l) => l.type === "CITY" || l.type === "AIRPORT"));
    const isSupportedType = searchType === "ONEWAY" || searchType === "ROUNDTRIP";
    return isSupportedType && hasValidFrom && hasValidTo;
};
export const useFareCalendar = ({ baseDate, mode, enabled = true, segmentIndex = 0 }) => {
    const [visibleMonths, setVisibleMonths] = useState([]);
    const actions = useActions(searchActions);
    const dateRange = useMemo(() => {
        if (visibleMonths.length === 0) {
            return undefined;
        }
        const dateToUse = baseDate || new Date();
        return getDateRangeFromVisibleMonths(visibleMonths, dateToUse);
    }, [visibleMonths, baseDate]);
    const { data: flightsMap, loading: fetchLoading, error, legend } = useFetchFareCalendar({ dateRange, enabled, segmentIndex });
    const priceMap = useMemo(() => {
        return createPriceMap(flightsMap);
    }, [flightsMap]);
    const handleMonthChange = (date) => {
        if (mode !== "vertical") {
            const months = getVisibleMonthIndexes(date);
            setVisibleMonths(months);
        }
    };
    useEffect(() => {
        if (!enabled) {
            return;
        }
        if (mode !== "vertical") {
            const dateToUse = baseDate || new Date();
            const months = getVisibleMonthIndexes(dateToUse);
            setVisibleMonths(months);
        }
    }, [baseDate, mode, enabled]);
    useEffect(() => {
        if (!enabled) {
            actions.fareCalendarClear();
        }
    }, [enabled, actions]);
    useEffect(() => {
        return () => {
            actions.fareCalendarClear();
        };
    }, [actions]);
    const loading = enabled ? fetchLoading : false;
    return {
        priceMap,
        visibleMonths,
        handleMonthChange,
        loading,
        error,
        legend
    };
};
